import React, { useState } from 'react';
import { PropertyForm } from './PropertyForm';
import { AxiosAPI } from '../../../../../../../helpers/AxiosAPI';
import { postAPI_Create_Property } from '../../../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import Validation from '../../../../../../../components/Validation';
function CreatePropertyForm({ propertyId, groupId }) {
  const [visible, setVisible] = useState(false);
  const [open,setOpen] = useState(false);
  const [msg,setMsg] =useState([]);
  const handleSubmit = (data) => {
    AxiosAPI({
      method: 'post',
      url: `${postAPI_Create_Property}`,
      data,
    })
      .then(
        (res) =>{
          if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
            && res.data.Messages !== null && res.data.Messages.length > 0) {
              setMsg(res.data.Messages);
              setOpen(true);
          }
          else {
            setVisible(false);
              setTimeout(() => {
                window.location.reload();
              }, 1000);
          }
        }
      );  
  };

  return (
    <div>
      <Button
        color="primary"
        outline
        size="lg"
        onClick={() => {
          setVisible(!visible);
        }}
        style={{ width: '100%', borderRadius: '6px' }}
      >
        + Create a New Property
      </Button>
      <PropertyForm
        formLabel="Create a New Property"
        visible={visible}
        toggle={() => {
          setVisible(!visible);
        }}
        submit={handleSubmit}
        groupId={groupId}
      />
      <Validation open={open} messages={msg} toggle={()=>{setOpen(!open)}}></Validation>
    </div>
    
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId } = settings;
  return {
    propertyId,
  };
};

export default injectIntl(connect(mapStateToProps, {})(CreatePropertyForm));
